(function Module() {
	'use strict';

	var util = require('../../static/js/imported-parnell-common-modules').util;

	mySynch.controller('SlidesController', [
		'$scope',
		'$window',
		'$timeout',
		'ApiFactory',
		'CookieFactory',
		'clientLoggerService',
		function SlidesController($s, $window, $timeout, api, cookies, log) {
			$s.currentSlide = null;
			$s.loadingSlide = true;
			$s.showEmailForm = false;
			$s.emailingSlide = false;
			$s.emailSent = false;
			$s.inputs = {
				email: null,
				message: null
			};

			$s.slides = [
				{
					name: '30-30 Fertility - Paul Fricke',
					fileName: '30-30-fertility-paul-fricke',
					thumbnailName: '30-30-fertility-paul-fricke',
					description: '4 Keys to Achieving a 30% Pregnancy Rate in a 30,000 lb. Dairy Herd'
				},
				{
					name: 'Bovine Estrous Cycle',
					fileName: 'bovine-estrous-cycle',
					thumbnailName: 'bovine-estrous-cycle',
					description: 'Bovine Estrous Cycle Graph'
				},
				{
					name: 'Cow Synchronization Protocols',
					fileName: 'cow-synchronization-protocols',
					thumbnailName: 'cow-synchronization-protocols',
					description: 'Presynchronization Methods Used Before Timed AI'
				},
				{
					name: 'Heifer Synchronization Protocols',
					fileName: 'heifer-synchronization-protocols',
					thumbnailName: 'heifer-synchronization-protocols',
					description: 'AI After Detection of Estrus'
				},
				{
					name: 'Hormone Synchrony',
					fileName: 'hormone-synchrony',
					thumbnailName: 'hormone-synchrony',
					description: 'Hormone Synchrony Graphs'
				}
			];
			$s.showSlide = function showSlide(slideFileName) {
				$('#pdf').remove();
				$('#pdf-container').append(
					'<object id="pdf" type="application/pdf" data="/files/slides/' +
					slideFileName + '.pdf"><span>PDF plugin is not available.</span></object>');

				$s.currentSlide = _.find($s.slides, {fileName: slideFileName});
				$s.loadingSlide = false;
			};

			$s.toggleEmailForm = function toggleEmailForm() {
				$s.showEmailForm = !$s.showEmailForm;

				if ($s.emailSent) {
					$s.hideEmail();
				}
			};
			$s.emailCurrentSlide = function emailCurrentSlide(isValid) {
				if (isValid) {
					var message = $s.inputs.message ? $s.inputs.message : 'Take a look at this slide called ' + $s.currentSlide.name + '.';

					$s.emailingSlide = true;

					api.emailSlide({
						emailAddress: $s.inputs.email,
						sender: {
							firstName: cookies.user.FirstName,
							lastName: cookies.user.LastName
						},
						message: message,
						slide: $s.currentSlide
					}, function slideEmailed(err, result) {
						$s.emailingSlide = false;

						if (err) {
							log.error(MSF.notify.danger('unable to email slide: ' + err));

							return;
						}

						$s.emailSent = true;
					});
				} else {
					var emailFormError = null;

					if ($s.formEmailCurrentSlide.$error.required) {
						_.forEach($s.formEmailCurrentSlide.$error.required, function appendErrorMessage(item, index, collection) {
							if (index === 0) {
								emailFormError = util.string.camelToTitle(item.$name);
							} else {
								emailFormError += util.string.camelToTitle(item.$name);
							}

							if ((index + 1) < collection.length) {
								if (((collection.length) - (index + 1)) === 1) {
									if (collection.length > 2) {
										emailFormError += ', and ';
									} else {
										emailFormError += ' and ';
									}
								} else {
									emailFormError += ', ';
								}
							}
						});

						emailFormError += ' is required.';
					}

					if ($s.formEmailCurrentSlide.$error.email) {
						if (emailFormError) {
							emailFormError += ' Email address is invalid.';
						} else {
							emailFormError = 'Email address is invalid.';
						}
					}

					MSF.notify.danger(emailFormError || 'An error has occured. Please check your inputs.');
				}
			};
			$s.resetEmail = function resetEmail() {
				$s.showEmailForm = true;
				$s.emailingSlide = false;
				$s.emailSent = false;
				$s.inputs = {
					email: null,
					message: null
				};
			};
			$s.hideEmail = function hideEmail() {
				$s.resetEmail();
				$s.showEmailForm = false;
			};

			$s.expandSlide = function expandSlide() {
				$window.open('/files/slides/' + $s.currentSlide.fileName + '.pdf', '_blank');
			};

			$timeout(function initializeTooltip() {
				$('[data-toggle="tooltip"]').tooltip();
				$s.showSlide($s.slides[0].fileName);
			}, 0);
		}
	]);
})();
